<template>
  <div>
  <p v-if="notification.statusId < 3" style="font-size:14px">Please check that the map below displays all the proposed activities for this FON. 
  If you need to make corrections, please return to the Mapping page.
  </p>
    <div class="mapContainer mb-3">
      <Map
        v-if="activityExtent"
        ref="map"
        mapId="review-map"
        class="fixedHeight"
        :geocoderEnabled="false"
        :key="mapKey"
        :extent="activityExtent"
      />
    </div>
    <b-list-group>
      <b-list-group-item
        class="font-sm"
        v-for="activity in activities"
        :key="`activity-${activity.activityId}`">
        <b-row>
          <b-col md="3">
            <DetailStacked label="Activity ID" :value="activity.activityId" />
          </b-col>
          <b-col md="3">
            <DetailStacked label="Activity Type" :value="activity.type.name" />
          </b-col>
          <b-col v-if="sizeCalculated(activity)" md="3">
            <DetailStacked label="Calculated Size" :value="activity.size" />
          </b-col>
          <b-col v-if="activityPermanenceRequired(activity)" md="3">
            <DetailStacked label="Permanent?" :value="getActivityPermanence(activity)" />
          </b-col>
          <b-col v-if="structureTypeRequired(activity)" md="3">
            <DetailStacked
              label="Structure Type"
              :value="getStructureTypeName(activity.structureTypeId)"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <br>
    <b-alert variant="danger" show>
      This map is ADVISORY, for planning purposes only. Actual
      ground conditions, water body locations, and
      <b-link target="_blank" :href="currentRegulationsUrl">current regulations</b-link>
       determine where and how MFS timber harvesting rules apply. Contact
      a <b-link target="_blank" :href="districtForesterUrl">MFS Forester</b-link> for
      additional information/assistance.
    </b-alert>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';
import DetailStacked from '@/components/DetailStacked.vue';
import Map from '@/components/Map.vue';

export default {
  name: 'MapDetails',
  components: {
    DetailStacked,
    Map,
  },
  data() {
    return {
      mapKey: true,
    };
  },
  created() {
    this.$store.dispatch(`${LookupModules.STRUCTURE_TYPES.namespace}/fetchOptions`);
  },
  computed: {
    ...mapState('Configuration', {
      currentRegulationsUrl: state => state.links.currentRegulations,
      districtForesterUrl: state => state.links.districtForesters,
    }),
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapState('Activity', {
      activityExtent: state => state.activityExtent,
      activities: state => state.activities,
    }),
    ...mapGetters('Activity', [
      'activityPermanenceRequired',
      'getActivityPermanence',
      'structureTypeRequired',
      'sizeCalculated',
    ]),
    ...mapGetters(LookupModules.STRUCTURE_TYPES.namespace, {
      getStructureTypeName: 'getName',
    }),
  },
  methods: {
    reloadMap() {
      this.mapKey = !this.mapKey;
    },
  },
};
</script>
<style>
#review-map{
    border: solid;
    border-width: 1px;
    border-color: #ADADAD;
}
</style>
